import { collection, query, where, getDocs } from '@firebase/firestore';
import { db } from './firebase';
import { COLLECTIONS } from './collections';
import { FundingSource } from '../types';
import { mapDocs } from '@utils/firestore';
import { FundingSourceSchema } from '../schemas/firestoreSchemas';
import { createPrefixedLogger } from '../utils/logger';

const log = createPrefixedLogger('api:fundingSources');

// Firestore's array-contains-any caps at 30 values — every service area the
// app knows about today is a handful, so the wildcard entry always fits.
const MAX_ARRAY_CONTAINS_ANY = 30;

export const fundingSourcesApi = {
  // One-shot read of every published funding source scoped to any of the
  // given area ids, plus every national/statewide program ('*'). Read-only
  // directory (no live subscription needed — a moderator hand-edits entries
  // rarely, see scripts/seed-funding-sources.ts).
  async listFundingSources(areaIds: string[]): Promise<FundingSource[]> {
    const wanted = Array.from(new Set([...areaIds, '*'])).slice(0, MAX_ARRAY_CONTAINS_ANY);
    if (wanted.length === 0) return [];

    const q = query(
      collection(db, COLLECTIONS.FUNDING_SOURCES),
      where('published', '==', true),
      where('areaIds', 'array-contains-any', wanted)
    );

    try {
      const snap = await getDocs(q);
      return mapDocs(snap, FundingSourceSchema);
    } catch (error) {
      log.error('listFundingSources failed:', error);
      throw error;
    }
  },
};
